import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { DataServiceService } from 'src/app/data-service.service';
import { IpeRoleNavItem, IpemarksService } from '../ipemarks.service';

@Component({
  selector: 'app-ipelinkes',
  templateUrl: './ipelinkes.component.html',
  styleUrls: ['./ipelinkes.component.scss']
})
export class IpelinkesComponent implements OnInit {
  /** Mobile click open/close */
  isSidebarOpen = false;
  /** Desktop hover open/close */
  isSidebarHovered = false;
  ipeNavItems: IpeRoleNavItem[] = [];
  rolesLoaded = false;

  constructor(
    private router: Router,
    private dataService: DataServiceService,
    private ipeService: IpemarksService
  ) {
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => {
        this.closeSidebar();
        this.isSidebarHovered = false;
      });
  }

  ngOnInit(): void {
    this.loadIpeRoleMenu();
  }

  get currentPageTitle(): string {
    const current = this.ipeNavItems.find((item) => this.isNavActive(item));
    return current?.label || this.ipeNavItems[0]?.label || '';
  }

  isActive(path: string): boolean {
    const current = (this.router.url || '').split('?')[0].replace(/^\//, '');
    const target = String(path || '').replace(/^\//, '');
    if (!target) {
      return false;
    }
    return current === target || current.endsWith('/' + target);
  }

  /** Highlight from the dynamic role menu: current route, or first item if none match. */
  isNavActive(item: IpeRoleNavItem): boolean {
    const matched = this.ipeNavItems.find((nav) => this.isActive(nav.path));
    if (matched) {
      return matched.path === item.path;
    }
    return this.ipeNavItems[0]?.path === item.path;
  }

  onSidebarEnter(): void {
    if (typeof window !== 'undefined' && window.innerWidth >= 768) {
      this.isSidebarHovered = true;
    }
  }

  onSidebarLeave(): void {
    if (typeof window !== 'undefined' && window.innerWidth >= 768) {
      this.isSidebarHovered = false;
    }
  }

  openSidebar(): void {
    this.isSidebarOpen = true;
  }

  closeSidebar(): void {
    this.isSidebarOpen = false;
  }

  private loadIpeRoleMenu(): void {
    this.dataService.rolemanagement().subscribe({
      next: (res: any) => {
        this.ipeNavItems = this.ipeService.parseIpeNavFromRoles(res);
        this.rolesLoaded = true;
        this.redirectIfCurrentFormNotAllowed();
      },
      error: () => {
        this.ipeNavItems = [];
        this.ipeService.ipeNavItems = [];
        this.ipeService.ipeRolesLoaded = true;
        this.rolesLoaded = true;
      }
    });
  }

  private redirectIfCurrentFormNotAllowed(): void {
    if (!this.ipeNavItems.length) {
      return;
    }
    const allowed = this.ipeNavItems.some((item) => this.isActive(item.path));
    if (!allowed) {
      this.router.navigateByUrl(this.ipeNavItems[0].path);
    }
  }
}
